/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ManageUserProfile } from '../../models/manage-user-profile';

export interface ApiUserUserInfoGet$Params {
  id?: string;
}

export function apiUserUserInfoGet(http: HttpClient, rootUrl: string, params?: ApiUserUserInfoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ManageUserProfile>> {
  const rb = new RequestBuilder(rootUrl, apiUserUserInfoGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ManageUserProfile>;
    })
  );
}

apiUserUserInfoGet.PATH = '/api/User/UserInfo';
